import { Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateService } from '@ngx-translate/core';

import { KeyValueUserRolesType } from '@models/common';
import { SelectUsersParameters } from '@module-instance/assignments/assign-users-dialog/assign-users-dialog.model';
import { Assignments, AssignmentsService } from '@module-instance/assignments/common';
import { SearchableListBoxConfig, SearchableListItemType } from '@shared/components/searchable-listbox';
import { SearchableListboxComponent } from '@shared/components/searchable-listbox/searchable-listbox.component';
import { CipoDialogHeaderComponent } from '@shared/dialogs';
import { CipoDialogModule } from '@shared/modules';
import { NotificationService } from '@shared/services';

@Component({
  selector: 'cipo-assign-users-dialog',
  imports: [MatExpansionModule, CipoDialogModule, SearchableListboxComponent, CipoDialogHeaderComponent],
  providers: [AssignmentsService],
  templateUrl: './assign-users-dialog.component.html',
})
export class AssignUsersDialogComponent {
  translate = inject(TranslateService);
  assignmentsService = inject(AssignmentsService);
  notification = inject(NotificationService);
  readonly dialogRef = inject(MatDialogRef<AssignUsersDialogComponent, Assignments[]>);
  readonly data = inject<SelectUsersParameters>(MAT_DIALOG_DATA);

  entityInstanceId: number;
  existingUsers: number[] = [];
  users = signal<KeyValueUserRolesType<number, string>[]>([]);
  listBoxConfig = signal<SearchableListBoxConfig>({
    columns: 3,
    multiple: true,
    searchable: true,
    noFoundMessage: 'assignments.notFound',
  });
  listBoxOptions = signal<SearchableListItemType[]>(null);
  listBoxValues = signal<number[]>([]);

  constructor() {
    this.entityInstanceId = this.data.entityInstanceId;
    this.existingUsers = this.data.existingUsers;

    this.loadUsers();
  }

  loadUsers() {
    this.listBoxOptions.set(null);
    this.listBoxValues.set([]);
    this.assignmentsService.getUsers(this.entityInstanceId, false, this.existingUsers).subscribe(list => {
      this.users.set(list);
      this.listBoxOptions.set(list);
    });
  }

  returnUsers() {
    const userIds = this.listBoxValues();
    const assignments: Assignments[] = this.users()
      .filter(u => userIds.includes(u.key))
      .map(u => {
        const globalRoles = u.roles ?? [];
        return {
          userId: u.key,
          roles: globalRoles,
          globalRoles: globalRoles,
          roleIds: globalRoles.map(r => r.key),
          userName: u.value,
          userEmail: u.email,
          userOrgName: u.orgName,
          deleting: false,
          edited: false,
          isPending: false,
          isNew: true,
        };
      });
    this.dialogRef.close(assignments);
  }
}
